module.exports = __webpack_public_path__ + "img/bin.2a2d1d40.png";